import { getAPI } from "src/utils/fetch";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

export async function fetchPendingRequests(instance) {
    try {
        const response = await getAPI({
            url: `${BACKEND_URL}/v1/user/access-requests`,
            instance,
        });
        const requests = await response.json();

        const datasourceIds = new Set<string>();
        for (const req of requests) {
            for (const ds of req.requested_datasources || []) {
                datasourceIds.add(ds.id);
            }
        }
        return datasourceIds;
    } catch (error) {
        console.error("Failed to fetch pending requests:", error);
        return new Set<string>();
    }
}
